<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import ErrorAlert from '../../../components/errorAlert.vue';
import { toast, variants } from "@/helpers/toaster";

export default {
  page: {
    title: "Zamenski artikli",
  },
  components: {PageHeader, Layout,ErrorAlert},
  props: {
  },
  data() {
    return {
      showReplaced: false,
      title: 'Zamenski artikli',
      currentPage: 1,
      perPage: 15,
      sortBy: 'client.status',
      sortDesc: true,
      search: '',
      fields: [
        {key: 'item.id', label: 'Id', sortable: false},
        {key: 'item.name', label: 'Artikal', sortable: false},
        {key: 'new_item_id', label: 'Novi Id', sortable: false, editable: true},
      ],
      replacementItems: [],
    }
  },
  watch: {
  },
  computed: {
    isSaveDisabled() {
      return false;
    },
    searchedReplacementItems () {
      return this.replacementItems.filter((replacementItem) => {
        let include = false;
        // search name
        include ||= replacementItem.item.name2?.toLowerCase().includes(this.search.toLowerCase());
        // search id
        include ||= replacementItem.item_id?.toString().includes(this.search.toLowerCase());

        if (this.showReplaced) {
          include &&= !!replacementItem.new_item_id;
        }

        return include;
      })
    },
  },
  async created() {
    await this.loadReplacementItems();
  },
  methods: {
    async save() {
      const items = this.replacementItems.filter(i => i.value || i.value === '' || i.value === '0').map(i => {
        return {
          id: i.id,
          item_id: i.item.id,
          new_item_id: i.value,
        }
      });
      this.$store.commit('loader/START_LOADING');

      try {
        const response = await axios.patch(`/super-admin/bulkReplacementItems`, {data: items})

        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            let item = this.replacementItems.find((l) => l.item.id === response.data[i].item_id);
            if (!item.id) item.id = response.data[i].id;
          }
        }
        toast('Uspešno snimanje zamenskih artikla.', variants.SUCCESS)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }

    },
    async loadReplacementItems() {
      let url = `/super-admin/replacementItems`;
      
      this.$store.commit('loader/START_LOADING');
      const limitsResponse = await axios.get(url);
      this.replacementItems = limitsResponse.data;
      this.$store.commit('loader/END_LOADING');
    },
    onNewItemIdEdit(item, value) {
      this.$set(item, 'value', value)
      this.$set(item, 'new_item_id', value)
    },
  }
}
</script>

<template>
  <Layout>
    <error-alert></error-alert>
    <PageHeader :title="title"/>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="search-box chat-search-box mb-2">
          <div class="position-relative">
            <input v-model="search" type="text" class="form-control" placeholder="Pretraži..."/>
            <i class="bx bx-search-alt search-icon"></i>
            <i class="bx bx-x clear-icon" @click="search = ''"></i>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 text-right">
        <b-button type="button" variant="success" @click="save()" :disabled="isSaveDisabled">Snimi</b-button>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 align-items-center justify-content-end d-flex">
        <b-form-checkbox
                v-model="showReplaced"
                :value="true"
                :unchecked-value="false"
                switch
        >
          Prikaži samo artikle sa zamenom
        </b-form-checkbox>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="searchedReplacementItems" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
        >
          <template v-slot:cell(item.name)="data">
            <a target="_blank" :href="`https://www.bigznet.rs/index.php?route=product/product&product_id=${data.item.item.id}`">{{ data.item.item.name2 }}</a>
          </template>
          <template v-slot:cell(new_item_id)="data">
            <div v-if="data.field.editable">
              <b-form-input v-model="data.value" @input="onNewItemIdEdit(data.item, data.value)" type="number" />
            </div>
            <div v-else>
              <h1>{{ data.value }}</h1>
            </div>
          </template>
        </b-table>

      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
  .autocomplete {
    width: 100%;
  }
</style>
